import React, { useState, useEffect } from 'react';
import { Facebook, Twitter, Linkedin, Instagram, Mail, Phone, MapPin } from 'lucide-react';
import { Link } from 'react-router-dom';
import logo from '../pages/assets/logo.jpeg';
import { db } from '../Config/Config';
import { doc, getDoc } from 'firebase/firestore';

const Footer = () => {
  const [contact, setContact] = useState(null);

  useEffect(() => {
    const fetchContact = async () => {
      try {
        const docRef = doc(db, 'website_content', 'contact');
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
          setContact(docSnap.data());
        }
      } catch (error) {
        console.error('Error fetching contact content for footer:', error);
      }
    };
    fetchContact();
  }, []);

  return (
    <footer className="bg-gray-900 pt-20 pb-24 md:pb-10 px-6 md:px-8 text-gray-400">
      <div className="max-w-7xl mx-auto flex flex-col lg:flex-row justify-between pb-16 border-b border-gray-800 gap-16 lg:gap-8">

        {/* Brand & Newsletter */}
        <div className="lg:w-1/3">
          <div className="text-white font-bold text-2xl flex items-center space-x-3 mb-6">
            <div className="bg-white p-1 rounded-xl shadow-sm w-12 h-12 flex items-center justify-center overflow-hidden">
              <img src={logo} alt="Cloud Services Technology Ltd" className="w-full h-full object-contain" />
            </div>
            <span>Cloud Services</span>
          </div>
          <p className="mb-8 leading-relaxed text-sm whitespace-pre-line">
            Cloud Services Technology Ltd<br />
            {contact?.contactAddress || "Suite 201 Antelope Walk\nDorchester, England\nDT1 1BE"}
          </p>
          {/* <div className="mb-4">
            <h4 className="text-white font-medium mb-3 text-sm">Subscribe for cloud updates</h4>
            <div className="flex bg-gray-800 rounded-xl overflow-hidden focus-within:ring-2 focus-within:ring-brand-primary transition-all shadow-inner">
              <input type="email" placeholder="Email address" className="px-4 py-3 w-full outline-none bg-transparent text-white placeholder-gray-500 text-sm" />
              <button className="bg-brand-primary text-white px-5 py-3 hover:bg-brand-medium transition-colors flex items-center justify-center min-h-[48px]">
                <ArrowRight size={18} />
              </button>
            </div>
          </div> */}
        </div>

        {/* Links Grid */}
        <div className="lg:w-1/2 grid grid-cols-2 md:grid-cols-3 gap-8 text-sm">
          <div>
            <h4 className="font-semibold text-white tracking-wider text-xs mb-6 uppercase">Company</h4>
            <ul className="space-y-2 md:space-y-4">
              <li><Link to="/" className="block py-2 md:py-0 hover:text-white transition-colors">Home</Link></li>
              <li><Link to="/about" className="block py-2 md:py-0 hover:text-white transition-colors">About Us</Link></li>
              <li><Link to="/services" className="block py-2 md:py-0 hover:text-white transition-colors">Solutions</Link></li>
              <li><Link to="/contact" className="block py-2 md:py-0 hover:text-white transition-colors">Contact</Link></li>
            </ul>
          </div>
          {/* <div>
            <h4 className="font-semibold text-white tracking-wider text-xs mb-6 uppercase">Resources</h4>
            <ul className="space-y-2 md:space-y-4">
              <li><Link to="/" className="block py-2 md:py-0 hover:text-white transition-colors">Client Portal</Link></li>
              <li><Link to="/" className="block py-2 md:py-0 hover:text-white transition-colors">Documentation</Link></li>
              <li><Link to="/" className="block py-2 md:py-0 hover:text-white transition-colors">System Status</Link></li>
            </ul>
          </div> */}
          <div>
            <h4 className="font-semibold text-white tracking-wider text-xs mb-6 uppercase">Contact</h4>
            <ul className="space-y-2 md:space-y-4">
              {contact?.contactPhone && (
                <li>
                  <a href={`tel:${(contact?.contactPhone || "").replace(/\s/g, '')}`} className="flex items-center block py-2 md:py-0 hover:text-white transition-colors group min-h-[48px] md:min-h-[24px]">
                    <Phone size={16} className="mr-3 text-brand-primary group-hover:text-white transition-colors" /> {contact?.contactPhone || ""}
                  </a>
                </li>
              )}
              <li>
                <a href={`mailto:${contact?.contactEmail || ""}`} className="flex items-center block py-2 md:py-0 hover:text-white transition-colors group min-h-[48px] md:min-h-[24px]">
                  <Mail size={16} className="mr-3 text-brand-primary group-hover:text-white transition-colors" /> {contact?.contactEmail || ""}
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="max-w-7xl mx-auto pt-8 flex flex-col md:flex-row justify-between items-center text-xs space-y-4 md:space-y-0 text-gray-500">
        <p>© 2024 Cloud Services Technology Ltd. All rights reserved.</p>
        <div className="flex space-x-2 md:space-x-6">
          <Link to="/" className="block px-4 py-2 md:p-0 hover:text-gray-300 transition-colors">Privacy</Link>
          <Link to="/" className="block px-4 py-2 md:p-0 hover:text-gray-300 transition-colors">Terms</Link>
          <Link to="/" className="block px-4 py-2 md:p-0 hover:text-gray-300 transition-colors">Cookies</Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
